import React from 'react';
import logo from 'assets/images/uy3-logo.png';

export default ({ title, subtitle }) => (
	<>
		<img src={window.__RUNTIME_CONFIG__.REACT_APP_MAIN_LOGO} alt='' className='wt-register-logo' />		
		<h4 className='uk-margin-remove'>{title}</h4>
		<p className='uk-margin-remove uk-text-small uk-text-center'>{subtitle}</p>
	</>
);